import React from 'react';
import { BookOpenIcon, ClockIcon, MapPinIcon, UsersIcon } from 'lucide-react';
export function TreatmentTypes() {
  return <section className="py-8 sm:py-12 md:py-16" data-id="element-707">
      <div className="max-w-6xl mx-auto px-4" data-id="element-708">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12" data-id="element-709">
          Todo lo que Incluye el Sistema
        </h2>
        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8" data-id="element-710">
          <div className="p-4 sm:p-6 border-2 border-orange-200 rounded-lg sm:rounded-xl bg-white" data-id="element-711">
            <BookOpenIcon className="w-10 h-10 sm:w-12 sm:h-12 text-orange-600 mb-3 sm:mb-4" data-id="element-712" />
            <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3" data-id="element-713">
              50 Recetas Express
            </h3>
            <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4" data-id="element-714">
              Cada una cronometrada y probada. De la sartén al plato en 15
              minutos exactos. Con ingredientes que encuentras en cualquier
              supermercado latino.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-715">
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-716">
                15 min exactos
              </span>
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-717">
                Probadas por familias
              </span>
            </div>
          </div>
          <div className="p-4 sm:p-6 border-2 border-orange-200 rounded-lg sm:rounded-xl bg-white" data-id="element-718">
            <ClockIcon className="w-10 h-10 sm:w-12 sm:h-12 text-orange-600 mb-3 sm:mb-4" data-id="element-719" />
            <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3" data-id="element-720">
              Menús Semanales Completos
            </h3>
            <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4" data-id="element-721">
              7 semanas de menús ya armados. 1 receta por día. Con listas de
              compras imprimibles que piensan por ti.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-722">
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-723">
                7 semanas listas
              </span>
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-724">
                Listas imprimibles
              </span>
            </div>
          </div>
          <div className="p-4 sm:p-6 border-2 border-orange-200 rounded-lg sm:rounded-xl bg-white" data-id="element-725">
            <MapPinIcon className="w-10 h-10 sm:w-12 sm:h-12 text-orange-600 mb-3 sm:mb-4" data-id="element-726" />
            <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3" data-id="element-727">
              Swaps por País LATAM
            </h3>
            <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4" data-id="element-728">
              ¿No hay cilantro? ¿El pollo está muy caro? Guía completa de
              sustituciones adaptadas a México, Argentina, Colombia, Chile y
              más.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-729">
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-730">
                15+ países
              </span>
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-731">
                Ingredientes locales
              </span>
            </div>
          </div>
          <div className="p-4 sm:p-6 border-2 border-orange-200 rounded-lg sm:rounded-xl bg-white" data-id="element-732">
            <UsersIcon className="w-10 h-10 sm:w-12 sm:h-12 text-orange-600 mb-3 sm:mb-4" data-id="element-733" />
            <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3" data-id="element-734">
              Comunidad
            </h3>
            <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4" data-id="element-735">
              Únete a nuestra comunidad exclusiva en Facebook con mamás que ya
              están transformando sus cenas. Comparte experiencias, recibe
              consejos y accede a recetas nuevas cada mes completamente gratis.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-736">
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-737">
                2,000+ mamás
              </span>
              <span className="px-2.5 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-700 rounded-full text-xs sm:text-sm" data-id="element-738">
                Soporte activo
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}